import React, { useEffect, useState } from "react";

export default function BloodDonationPopup() {
  const [visible, setVisible] = useState(false); // Start with false

  useEffect(() => {
    const hasShown = localStorage.getItem("bloodDonationPopupShown");

    if (!hasShown) {
      setVisible(true); // Show popup on first load only
      localStorage.setItem("bloodDonationPopupShown", "true");

      const timer = setTimeout(() => {
        setVisible(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, []); // Run only once

  if (!visible) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.card}>
        <button onClick={() => setVisible(false)} style={styles.close}>
          &times;
        </button>

        <div style={styles.content}>
          <img
            src="assets/img/blooddonation/blooddonation.png"
            alt="Blood Donation"
            style={styles.image}
          />
          <div style={styles.textContent}>
            <h1 style={styles.title}>Donate Blood, Save Lives</h1>
            <p style={styles.description}>
              Just 1 pint of your blood can save up to 3 lives. Be a hero today — it takes only 15 minutes!
            </p>
            <ul style={styles.bullets}>
              <li>✔ Safe & simple process</li>
              <li>✔ Free health check & snacks</li>
              <li>✔ Help hospitals in urgent need</li>
            </ul>
            <a href="/donateblood" style={styles.cta}>Join the Blood Drive</a>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    padding: "10px",
  },
  card: {
    position: "relative",
    width: "100%",
    maxWidth: "700px", // Reduced width
    background: "#fff",
    borderRadius: "16px",
    boxShadow: "0 20px 50px rgba(0,0,0,0.2)",
    overflow: "hidden",
    animation: "fadeIn 0.4s ease",
  },
  close: {
    position: "absolute",
    top: "10px",
    right: "15px",
    fontSize: "24px",
    background: "none",
    border: "none",
    color: "#444",
    cursor: "pointer",
    zIndex: 10,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",

    // Responsive layout switch
    gap: "20px",
  },
  image: {
    width: "100%",
    maxHeight: "200px",
    objectFit: "cover",
  },
  textContent: {
    padding: "20px",
    textAlign: "center",
  },
  title: {
    fontSize: "22px",
    fontWeight: "700",
    color: "#c62828",
    marginBottom: "10px",
  },
  description: {
    fontSize: "15px",
    marginBottom: "15px",
    color: "#333",
  },
  bullets: {
    fontSize: "14px",
    listStyle: "none",
    paddingLeft: 0,
    color: "#555",
    marginBottom: "20px",
  },
  cta: {
    display: "inline-block",
    padding: "10px 22px",
    background: "#c62828",
    color: "#fff",
    fontSize: "14px",
    fontWeight: "bold",
    borderRadius: "6px",
    textDecoration: "none",
    boxShadow: "0 3px 10px rgba(198, 40, 40, 0.4)",
    transition: "transform 0.2s ease",
  },
};
